<template>
    <div>
        <page-title heading="Penjualan" :breadcrumb="[
            {
                label: 'Penjualan',
                link: '/klinik/penjualan'
            },
            {
                label: infoKasir.invoice === ''?'List Pembayaran':'Detail Penjualan',
                active: true
            }
        ]" />
        <div class="container-fluid">
            <div class="card card-box border-0">
                <div class="card-header border-0 py-4 px-5">
                    <div class="d-flex flex-column w-100">
                        <b-row class="mb-1">
                            <b-col cols="5">
                                <b-row class="mb-2">
                                    <b-col cols="4 text-nowrap">Tanggal Transaksi</b-col>
                                    <b-col v-if="infoKasir.tanggal" cols="8">: {{ infoKasir.tanggal }}</b-col>
                                    <b-col v-else cols="8">: 
                                        <template v-if="dataLoaded">
                                            -
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4">Jam Transaksi</b-col>
                                    <b-col v-if="infoKasir.jam" cols="8">: {{ infoKasir.jam }} WIB</b-col>
                                    <b-col v-else cols="8">: 
                                        <template v-if="dataLoaded">
                                            -
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row  class="mb-2">
                                    <b-col cols="4">No. Invoice</b-col>
                                    <b-col cols="8">:
                                        <template v-if="dataLoaded">
                                            {{ infoKasir.invoice === "" ? dataPembayaran.no_invoice : "-" }}
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col cols="4">Kasir</b-col>
                                    <b-col cols="8">: {{ !infoKasir.kasir.nama ? dataPembayaran.kasir : infoKasir.kasir.nama }}</b-col>
                                </b-row>
                            </b-col>


                        </b-row>
                    </div>
                </div>
                <div class="card-body">

                    <template v-if="dataPembayaran.status == 'LUNAS'
                        || dataPembayaran.status == 'lunas'
                        || dataPembayaran.status == 'Lunas'
                        ">
                        <DetailPembayaran @valueChanged="dataTableChanged" @groupLayananType="calcLayananType"
                            @layananDuplicateErrorState="layananDuplicateError = $event" @isBayarStatus="isBayar = $event"
                            :bayar="isBayar" :bpjs="isBpjs" :items="pembayaranDetails" :errorMessage="statusMessage"
                            :poli="dataPembayaran.poli_id" />
                    </template>
                    <template v-else>
                        <DetailPembayaran @valueChanged="dataTableChanged" @groupLayananType="calcLayananType"
                            @layananDuplicateErrorState="layananDuplicateError = $event" @isBayarStatus="isBayar = $event"
                            :bayar="isBayar" :bpjs="isBpjs" :items="pembayaranDetails" :errorMessage="statusMessage"
                            :poli="dataPembayaran.poli_id" @validationInputEvt="validationInput" />
                    </template>
                </div>
                <div class="card-footer">
                    <div class="py-2 d-flex flex-row justify-content-end">
                        <b-container fluid>
                            <b-row>
                                <b-col cols="5" offset="7">
                                    <b-form-row v-if="isBpjs" class="d-flex align-items-center w-100 py-2">
                                        <b-col cols="5" class="font-weight-bold">Total Dibayar BPJS</b-col>
                                        <b-col cols="7">
                                            <money v-model="totalBpjs" v-bind="money" disabled
                                                :class="isBayar ? 'is-paid form-control text-right' : 'form-control text-right'" />
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row class="d-flex align-items-center w-100 py-2">
                                        <b-col cols="5" class="font-weight-bold">Total Dibayar</b-col>
                                        <b-col cols="7">
                                            <money v-model="totalMandiri" v-bind="money" disabled
                                                :class="isBayar ? 'is-paid form-control text-right' : 'form-control text-right'" />
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row class="d-flex align-items-center w-100 py-2">
                                        <b-col cols="5" class="font-weight-bold">Diskon</b-col>
                                        <b-col cols="7 mb-1">
                                            <vue-select class="opt_select" placeholder="Pilih Jenis Diskon"
                                                :options="['Persentase', 'Rupiah']" v-model="jenis_potongan"
                                                @input="setSelected" :disabled="isBayar" />
                                        </b-col>
                                        <b-col cols="5"></b-col>
                                        <b-col cols="7">
                                            <template v-if="jenis_potongan === 'Persentase'">
                                                <b-input-group prepend="%">
                                                    <b-form-input v-model.lazy="potongan"
                                                        @keypress="isNumberPersentase($event)" :disabled="isBayar"
                                                        :class="isBayar ? 'is-paid text-right' : 'text-right'" />
                                                </b-input-group>
                                            </template>
                                            <template v-if="jenis_potongan === 'Rupiah'">
                                                <b-input-group prepend="Rp">
                                                    <money v-model="potongan" v-bind="money2"
                                                        @keypress.native="isNumberRupiah($event)" :disabled="isBayar"
                                                        :class="isBayar ? 'is-paid form-control text-right' : 'form-control text-right'" />
                                                </b-input-group>
                                            </template>
                                        </b-col>
                                    </b-form-row>
                                    <b-form-row class="d-flex align-items-center w-100 py-2">
                                        <b-col cols="5" class="font-weight-bold">Total Nett</b-col>
                                        <b-col cols="7">
                                            <money v-model="net" v-bind="money" disabled
                                                :class="isBayar ? 'is-paid form-control text-right' : 'form-control text-right'" />
                                        </b-col>
                                    </b-form-row>
                                </b-col>
                                <b-col cols="6" offset="6">
                                    <b-form-row class="d-flex align-items-right w-100 py-2">
                                        <b-col class="pt-2" align="right">
                                            <b-button variant="danger" class="text-uppercase mr-3" @click="kembali"
                                                v-if="false">
                                                kembali</b-button>
                                            <b-button :variant="isBayar ? 'dark' : 'success'" class="text-uppercase mr-3"
                                                @click="simpanPembayaran('preview-struk')"
                                                :disabled="isBayar || !stokAvailable || statusMessage.length > 0">preview
                                                struk</b-button>
                                            <b-button variant="info" class="text-uppercase mr-3"
                                                @click="simpanPembayaran('save')"
                                                :disabled="!stokAvailable">simpan</b-button>
                                            <b-button v-if="this.layananMandiri.length > 0"
                                                :variant="isBayar ? 'dark' : 'primary'" class="text-uppercase"
                                                @click="bayarModal" :disabled="isBayar || !stokAvailable">bayar</b-button>
                                        </b-col>
                                    </b-form-row>
                                </b-col>
                            </b-row>
                        </b-container>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modalMetodePembayaran" title="Pilih Metode Pembayaran Anda" ok-only no-close-on-backdrop
            @hidden="isPembayaran = false">
            <vue-select class="opt_select" placeholder="Pilih metode pembayaran" :options="['Tunai', 'Transfer']"
                v-model="pembayaran.metode" />
            <b-row v-if="pembayaran.metode == 'Transfer'" class="mt-3">
                <b-col cols="6">
                    <label for="bank">Bank Pengirim <small style="color:red;">*</small></label>
                    <b-form-input type="text" v-model="pembayaran.bankSender" />
                    <small style="color:red;"
                        v-if="(pembayaran.bankSender == null || pembayaran.bankSender == '') && isPembayaran">Kolom harus
                        diisi</small>
                </b-col>
                <b-col cols="6">
                    <label for="bank">Nama Pengirim <small style="color:red;">*</small></label>
                    <b-form-input type="text" v-model="pembayaran.nameSender" />
                    <small style="color:red;"
                        v-if="(pembayaran.nameSender == null || pembayaran.nameSender == '') && isPembayaran">Kolom harus
                        diisi</small>
                </b-col>
            </b-row>
            <template v-slot:modal-footer>
                <div class="w-100">
                    <b-button size="sm" class="float-right btn-cancel"
                    @click="$bvModal.hide('modalMetodePembayaran')">
                        Batal
                    </b-button>
                    <b-button size="sm" class="btn-submit float-right mr-2" @click="bayarPembayaran">
                        Lanjutkan Pembayaran
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex"
import startCase from "lodash/startCase"
import moment from "moment"
moment.locale('id')
import { Money } from 'v-money'

export default {
    components: {
        DetailPembayaran: () => import("./DetailPembayaran.vue"),
        "vue-select": () => import("vue-select"),
        Money
    },
    data: () => ({
        money: {
            decimal: "",
            thousands: ",",
            prefix: "Rp. ",
            suffix: "",
            precision: 0,
            masked: false
        },
        money2: {
            decimal: "",
            thousands: ",",
            prefix: "",
            suffix: "",
            precision: 0,
            masked: false
        },
        dataPembayaran: [],
        total: 0,
        totalMandiri: 0,
        totalBpjs: 0,
        jenis_potongan: null,
        net: 0,
        potongan: 0,
        pembayaranDetails: [],
        postData: {
            klinik_id: null,
            id: null,
            status: null,
            perawat_id: null,
            potongan: 0,
            jenis_potongan: null,
            total: 0,
            total_net: 0,
            detail_pembayaran: []
        },
        pembayaran: {
            metode: null,
            bankSender: null,
            nameSender: null
        },
        layananDuplicateError: false,
        dataTable: [],
        optTenagaMedis: [],
        tenagaMedis: null,
        isBayar: false,
        isBpjs: false,
        isPembayaran: false,
        stokAvailable: true,
        tindakanBpjs: [],
        obatBpjs: [],
        layananMandiri: [],
        statusMessage: [],
        infoKasir: {
            tanggal: "",
            jam: "",
            invoice: "",
            kasir: {}
        },
        dataLoaded: false
    }),
    computed: {
        ...mapGetters(['getKlinikId']),
        now() {
            return moment().format('dddd' + ', ' + "Do MMMM YYYY");
        },
        waktuMasuk() {
            return moment(this.dataPembayaran.created_at).format("DD-MMM-YYYY, HH:mm");
        }
    },
    watch: {
        jenis_potongan(newVal) {
            this.postData.jenis_potongan = newVal
            this.calcDataTable()
        },
        potongan(newVal) {
            if (!newVal) {
                this.potongan = ''
            }
            this.postData.potongan = newVal
            this.calcDataTable()
        },
        tenagaMedis(newVal) {
            if (this.tenagaMedis != null) {
                this.postData.perawat_id = newVal.value
                this.calcDataTable()
            }
        }
    },
    async mounted() {
        await this.fetchTenagaMedis()

        if (this.$route.name === 'penjualan-tambah') {
            this.fetchAddPenjualan()
        } else {
            this.fetchGetPembayaran()
            .then(() => {
                this.optTenagaMedis.forEach(item => {
                    if (item.value == this.dataPembayaran.perawat_id) {
                        this.tenagaMedis = item
                    }
                })
                this.dataLoaded = true;
            })
        }

    },
    methods: {
        ...mapMutations({
            setStrukVal: "struk/SET_STRUK_VAL"
        }),
        calcLayananType(value) {
            this.tindakanBpjs = value.tindakanBpjs;
            let tindakanBpjs = value.tindakanBpjs.reduce((prev, val) => {
                return prev + val.subtotal_tarif_net;
            }, 0)

            this.obatBpjs = value.obatBpjs;
            let obatBpjs = value.obatBpjs.reduce((prev, val) => {
                return prev + val.subtotal_tarif_net;
            }, 0)

            this.layananMandiri = value.mandiri;
            let bayarMandiri = value.mandiri.reduce((prev, val) => {
                return prev + val.subtotal_tarif_net;
            }, 0)

            this.totalBpjs = tindakanBpjs + obatBpjs;
            this.totalMandiri = bayarMandiri;
        },
        setSelected() {
            this.potongan = 0
        },
        activeTitle(){
           return infoKasir.invoice === "" ? "DETAIL PENJUALAN":
                "BUAT PENJUALAN";
        },
        isNumberPersentase: function (evt) {
            let theEvent = evt || window.event
            let key = theEvent.keyCode || theEvent.which
            key = String.fromCharCode(key)
            if (key.length == 0) return
            let regex = /^[0-9,\b]+$/
            if (!regex.test(key)) {
                theEvent.returnValue = false
                if (theEvent.preventDefault) theEvent.preventDefault()
            }

            let regex2 = /^[0-9]*(,[0-9]{0,2})?$/
            if (regex2.test(this.potongan + evt.key) == false || parseInt(this.potongan + evt.key) > 100 || parseInt(this
                .potongan + evt.key) < 0) {
                evt.preventDefault()
            }
            return true
        },
        isNumberRupiah: function (evt) {
            let theEvent = evt || window.event
            let key = theEvent.keyCode || theEvent.which
            key = String.fromCharCode(key)
            if (key.length == 0) return
            let regex = /^[0-9\b]+$/
            if (!regex.test(key)) {
                theEvent.returnValue = false
                if (theEvent.preventDefault) theEvent.preventDefault()
            }

            if (parseInt(this.potongan + evt.key) > this.total || parseInt(this.potongan + evt.key) < 0) {
                evt.preventDefault()
            }

            return true
        },
        calc(val) {
            let total_tmp = 0
            let detail_pembayaran = []
            val.forEach(item => {
                total_tmp += item.subtotal_tarif_net
                detail_pembayaran.push({
                    id: item.id,
                    from_bpjs: item.from_bpjs,
                    bpjs_sk_type: item.bpjs_sk_type,
                    pembayaran_id: item.pembayaran_id,
                    layanan_id: item.layanan_id,
                    kode_layanan: item.kode_layanan,
                    nama_layanan: item.nama_layanan,
                    tarif: item.tarif,
                    potongan: item.potongan,
                    jenis_potongan: item.jenis_potongan,
                    quantity: item.quantity,
                    satuan_id: item.satuan_id,
                    keterangan: item.keterangan,
                    subtotal_tarif: item.subtotal_tarif,
                    subtotal_tarif_net: item.subtotal_tarif_net,
                    komisi_id: item.komisi_id,
                    komisi: item.komisi === undefined ? [] : item.komisi.filter(v => (v.user_id !== null)),
                })
            })
            for (let i in val) {
                if (!val[i].stok_available && val[i].from_bpjs == 0) {
                    this.stokAvailable = false;
                    break;
                } else {
                    this.stokAvailable = true;
                }
            }
            this.total = total_tmp

            this.postData.klinik_id = this.getKlinikId
            this.postData.id = this.dataPembayaran.id
            this.postData.status = !this.dataPembayaran.status ? 'BELUM LUNAS' : this.dataPembayaran.status

            this.postData.detail_pembayaran = detail_pembayaran
            this.postData.total = this.total

            if (this.layananMandiri.length == 0 && (this.obatBpjs.length > 0 || this.tindakanBpjs.length > 0)) {
                this.postData.status = 'BPJS';
            }

            let harga_diskon = 0
            if (this.jenis_potongan == 'Persentase') {
                this.postData.jenis_potongan = 'PERSENTASE'
                let fl = parseFloat((this.potongan + '').replace(',', '.'))
                harga_diskon = ((fl / 100) * this.totalMandiri)
            } else if (this.jenis_potongan == 'Rupiah') {
                this.postData.jenis_potongan = 'RUPIAH'
                harga_diskon = this.potongan
            }
            this.net = this.totalMandiri - harga_diskon
            this.postData.total_net = this.net
        },
        validationInput(data) {
            let detPem = data;
            let status = []
            this.statusMessage = status;

            detPem.forEach((item, index) => {
                if (item.nama_layanan == '' || item.nama_layanan == null) {
                    status.push({
                        status: false,
                        message: 'Wajib diisi',
                        key: 'nama_layanan',
                        index
                    })
                }

                if (item.quantity < 0 || isNaN(parseInt(item.quantity)) || item.quantity == null) {
                    status.push({
                        status: false,
                        message: 'Wajib diisi',
                        key: 'quantity',
                        index
                    })
                }
            })

            if (this.layananDuplicateError) {
                status.push({
                    status: false,
                    message: 'Nama layanan tidak boleh sama',
                    key: 'nama_layanan',
                    index: 999
                })
            }
            this.statusMessage = status;
        },
        bayarModal() {
            if (this.postData.detail_pembayaran.length == 0) {
                this.$swal({
                    type: 'error',
                    title: startCase("gagal"),
                    text: "Tindakan/Obat/Bahan Habis Pakai masih kosong"
                })
                return;
            }

            this.validationInput(this.postData.detail_pembayaran);

            if (this.statusMessage.length) {
                let isRequired = this.statusMessage.find(item => item.message.includes('diisi'));

                if (isRequired) {
                    this.$swal({
                        type: 'error',
                        title: startCase("gagal"),
                        text: "Seluruh Kolom Harus Diisi"
                    })
                    return;
                }

                if (this.layananDuplicateError) {
                    this.$swal({
                        type: 'error',
                        title: startCase("gagal"),
                        text: "Pilihan Tidak Boleh Sama"
                    })
                    return;
                }
                return;
            }

            let isRoute = this.$router.currentRoute.params.id
            let isError = this.statusMessage.filter((item) => item.status == false).length
            if (isError == 0) {
                this.$swal({
                    title: startCase("Bayar"),
                    text: `Apakah Anda yakin untuk melakukan pembayaran?`,
                    type: "warning",
                    showCancelButton: true,
                    allowOutsideClick: false,
                    cancelButtonText: startCase("tidak"),
                    confirmButtonText: startCase("ya")
                }).then(res => {
                    if (res.value) {

                        let axiosConfig = {
                            url: !isRoute ? `penjualan/store` : `penjualan/update/${isRoute}`,
                            method: isRoute ? 'PUT' : 'POST',
                            data: this.postData
                        }
                        this.$axios(axiosConfig)
                            .then((res) => {
                                const { status, data } = res.data
                                if (status) {
                                    this.$bvModal.show('modalMetodePembayaran')
                                    this.infoKasir.invoice = data.pembayaran.no_invoice
                                    this.$router.push({ name: 'penjualan-tambah-save', params: { id: data.pembayaran.id } });
                                } else {
                                    this.$swal({
                                        type: 'error',
                                        title: startCase("gagal"),
                                        text: startCase("Pembayaran Gagal")
                                    })
                                }
                            })
                            .catch((error) => {
                                this.$swal({
                                    type: 'error',
                                    title: startCase("gagal"),
                                    text: startCase("Pembayaran Gagal")
                                }).then(res => {
                                    if (res.value) {
                                        this.$router.go({
                                            name: "penjualan-tambah",
                                            params: {
                                                id: isRoute
                                            }
                                        })
                                    }
                                })
                            })
                    }
                })
            }
        },
        previewStruk(id) {
            this.setStrukVal(this.pembayaran.metode)
            const url = this.$router.resolve({
                name: "penjualan-struk",
                params: {
                    id: id
                }
            })
            window.open(url.href, '_blank')
        },
        async fetchGetPembayaran() {
            try {
                let isRoute = this.$router.currentRoute.params.id
                const res = await this.$axios.get(`penjualan/detail/${isRoute}`)
                const { status, data } = res.data

                if (status == false || data.status == "LUNAS") {
                    this.isBayar = true
                }

                if (data.kategori == "BPJS") {
                    this.isBpjs = true;
                }

                this.dataPembayaran = data
                if (data.jenis_potongan) {
                    let s = data.jenis_potongan
                    this.jenis_potongan = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
                }

                this.potongan = +data.potongan

                data.detail.forEach(async (item, i) => {
                    let sc = {}
                    if (item.komisi.length > 0) {
                        item.komisi.forEach(v => {
                            sc[v.role_name] = { id: v.user_id, name: v.user_name }
                        })
                    }
                    let stock = null;
                    if (item.layanan && item.from_bpjs == 0) {
                        stock = item.layanan.stok;
                    } else {
                        // stock = item.last_stock;
                        stock = item.bpjs_sedia;
                    }
                    this.pembayaranDetails.push({
                        no: i + 1,
                        id: item.id,
                        from_bpjs: item.from_bpjs,
                        bpjs_sk_type: item.bpjs_sk_type,
                        pembayaran_id: item.pembayaran_id,
                        layanan_id: item.layanan_id,
                        kode_layanan: item.kode_layanan,
                        nama_layanan: item.nama_layanan,
                        layanan: `${item.nama_layanan.length >= 45 ? item.nama_layanan.substring(0, 45) + ' ...' : item.nama_layanan} - ${item.kode_layanan}`,
                        tarif: item.tarif,
                        potongan: Math.trunc(item.potongan) || 0,
                        jenis_potongan: item.jenis_potongan,
                        quantity: item.quantity,
                        satuan_id: item.satuan_id,
                        keterangan: item.keterangan,
                        subtotal_tarif: item.subtotal_tarif,
                        subtotal_tarif_net: item.subtotal_tarif_net,
                        readonly: item.jenis_potongan == null ? true : false,
                        selectedComission: sc,
                        is_click: false,
                        is_comission: false,
                        stok: stock,
                        stok_available: stock != null && !isNaN(parseInt(item.quantity)) ? parseInt(stock) >= parseInt(item.quantity) : true,
                    })
                })
                this.pembayaranDetails = this.getLayananType(this.pembayaranDetails)
                this.calc(this.pembayaranDetails)
            } catch (err) {
            }
        },
        getLayananType(data) {
            let layananNormal = []
            let obatBpjs = []
            let tindakanBpjs = []

            data.forEach((item) => {
                if (item.from_bpjs == 0 || item.from_bpjs == '') {
                    layananNormal.push(item);
                } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 0) {
                    tindakanBpjs.push(item);
                } else if (item.from_bpjs == 1 && item.bpjs_sk_type == 1) {
                    obatBpjs.push(item);
                }
            })

            return [
                ...tindakanBpjs, ...obatBpjs, ...layananNormal
            ];
        },
        async fetchTenagaMedis(search = '') {
            let param = `klinik_id=${this.getKlinikId}`
            if (search != '' && search != null) param += `&nama=${search}`

            const res = await this.$axios.get(
                `klinik/get-pic-layanan?${param}`
            )
            const { status, data } = res.data

            if (status) {
                this.optTenagaMedis = [
                    ...data.map(item => {
                        return {
                            value: item.id,
                            label: item.nama
                        }
                    })
                ]
            }
        },
        simpanPembayaran(type) {
            let detPem = this.postData.detail_pembayaran
            let status = []
            let details = []
            let isRoute = this.$router.currentRoute.params.id

            if (detPem.length == 0) {
                this.$swal({
                    type: 'error',
                    title: startCase("gagal"),
                    text: "Tindakan/Obat/Bahan Habis Pakai masih kosong"
                })
                return;
            }

            this.validationInput(detPem);

            if (this.statusMessage.length) {
                let isRequired = this.statusMessage.find(item => item.message.includes('diisi'));

                if (isRequired) {
                    this.$swal({
                        type: 'error',
                        title: startCase("gagal"),
                        text: "Seluruh Kolom Harus Diisi"
                    })
                    return;
                }

                if (this.layananDuplicateError) {
                    this.$swal({
                        type: 'error',
                        title: startCase("gagal"),
                        text: "Pilihan Tidak Boleh Sama"
                    })
                    return;
                }
                return;
            }

            detPem.forEach(item => {
                if (item.nama_layanan != '' && item.nama_layanan != null) {
                    details.push(item)
                }
            })
            let isError = this.statusMessage.filter((item) => item.status == false).length
            if (isError == 0) {
                this.postData.status = this.isBayar ? 'LUNAS' : 'BELUM LUNAS'

                if (this.isBpjs) {
                    if (this.layananMandiri.length == 0 && (this.obatBpjs.length > 0 || this.tindakanBpjs.length > 0)) {
                        this.postData.status = 'BPJS';
                    }
                }

                let axiosConfig = {
                    url: !isRoute ? `penjualan/store` : `penjualan/update/${isRoute}`,
                    method: isRoute ? 'PUT' : 'POST',
                    data: { ...this.postData, details: details }
                }

                this.$axios(axiosConfig)
                    .then((res) => {
                        const { status, data } = res.data
                        if (status) {
                            if (type == 'preview-struk') {
                                this.previewStruk(data.pembayaran.id)
                            } else {
                                this.$swal({
                                    type: 'success',
                                    text: this.isBayar ? 'Pengaturan komisi berhasil disimpan' : 'Pembayaran berhasil disimpan',
                                    confirmButtonText: startCase("ya")
                                })
                                    .then(() => {
                                        this.infoKasir.invoice = data.pembayaran.no_invoice
                                        // this.$router.push({ name: 'penjualan-tambah-save', params: { id: data.pembayaran.id } });
                                        this.$router.push({
                                            name: 'penjualan-list'
                                        })
                                    })
                            }
                        } else {
                            this.$swal({
                                type: 'error',
                                text: 'Pembayaran gagal disimpan',
                                confirmButtonText: startCase("ok")
                            })
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            type: 'error',
                            text: 'Pembayaran gagal disimpan',
                            confirmButtonText: startCase("ok")
                        })
                            .then(res => {
                                if (res.value) {
                                    this.$router.go({
                                        name: "penjualan-tambah-save",
                                        params: {
                                            id: isRoute
                                        }
                                    })
                                }
                            })
                    })
            }
        },
        bayarPembayaran() {
            this.isPembayaran = true
            if (this.cekTransferData()) {
                this.$bvModal.hide('modalMetodePembayaran')
                let isRoute = this.$router.currentRoute.params.id

                // proses bayar
                this.$axios.put(`klinik/tatalaksana/bayar/${isRoute}`, {
                    id: isRoute,
                    status: "LUNAS",
                    jenis_pembayaran: this.pembayaran.metode.toUpperCase(),
                    nama_bank: this.pembayaran.bankSender || null,
                    nama_rekening: this.pembayaran.nameSender || null
                })
                    .then((res) => {
                        if (res.data.status) {
                            this.$swal({
                                type: 'success',
                                text: 'Pembayaran Berhasil',
                                confirmButtonText: startCase("ya")
                            })
                                .then(() => {
                                    this.previewStruk(isRoute)
                                    this.$router.push({
                                        name: 'penjualan-list'
                                    })
                                })
                        } else {
                            this.$swal({
                                type: 'error',
                                title: 'Gagal',
                                text: 'Pembayaran tidak berhasil',
                                confirmButtonText: startCase("ya")
                            })
                        }
                    }).catch((error) => {
                        this.$swal({
                            type: 'error',
                            title: 'Gagal',
                            text: 'Pembayaran tidak berhasil',
                            confirmButtonText: startCase("ya")
                        })
                    })
            }
        },
        cekTransferData() {
            let cek = true
            if (this.pembayaran.metode == 'Transfer') {
                if (this.pembayaran.bankSender == null || this.pembayaran.bankSender == '') cek = false
                if (this.pembayaran.nameSender == null || this.pembayaran.nameSender == '') cek = false
            }
            return cek
        },
        kembali() {
            this.$router.push({
                name: 'klinik-pembayaran-list'
            })
        },
        dataTableChanged(data) {
            this.dataTable = data
            this.calcDataTable()
        },
        calcDataTable() {
            this.calc(this.dataTable)
        },
        labelStartCase(val) {
            return startCase(val)
        },
        async fetchAddPenjualan() {
            try {
                const res = await this.$axios.get(`penjualan/add`)

                const { success, data } = res.data

                if (success) {
                    this.infoKasir = data
                    this.dataLoaded = true;
                }
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Gagal',
                    text: error,
                })
            }
        }
    },
    filters: {
        formatDate(dateString) {
            return moment(dateString).format('DD/MMM/YYYY');
        },
        formatTime(timeStirng) {
            return moment(timeStirng).format('HH:mm');
        }
    },
}
</script>

<style lang="scss" scoped>
.card {
    .card-header {
        background-color: #dcebff;
    }
}

.hal-pembayaran {
    zoom: 84%;
}

input[disabled="disabled"] {
    background-color: transparent;
}
</style>

<style lang="scss">
.opt_select .vs__dropdown-toggle .vs__selected-options .vs__search::placeholder {
    color: #d1d2db !important;
}

.modal-backdrop {
    opacity: 0.5 !important;
}

.is-paid {
    cursor: not-allowed !important;
    background-color: #eeeff8 !important;
}

.card-footer {
    .input-group-text {
        font-weight: 600;
    }
}

.btn-cancel {
    background-color: #aaa;
    border: none;
    color: white;
  }

  .btn-submit {
    background-color: #1791EE;
    border: none;
    color: white;
  }
</style>
